/**
 * 应用初始化组合式函数
 */

import { nextTick, onMounted, onUnmounted, provide, ref } from 'vue';
import { setFontSize, getAppBaseInfo, isInDocoiApp } from '../utils/app';
import { isIOS } from '../utils/device';
import { setStorage } from '../utils/storage';
import { getParamsByUrl } from '../utils/url';
import JSBridge from '../bridge';
import { GlobalAuth } from '../utils/auth';
import { getUserInfo } from '../request/apis/login';

export interface UseAppInitOptions {
  designWidth?: number;
  baseFontSize?: number;
  pageScale?: number;
  navOriginalHeight?: number;
}

/**
 * 应用初始化逻辑
 * @param options 初始化选项
 */
export function useAppInit(options: UseAppInitOptions = {}) {
	let { designWidth = 375, baseFontSize = 37.5, pageScale = 1.25, navOriginalHeight = 46 } = options;

  const statusHeight = ref(0);
  const navHeight = ref(0); // statusHeight + 导航栏高度
  const appBaseInfo = getAppBaseInfo();
  const urlParams = getParamsByUrl(window.location.href);
  const isHome = ['true', '1'].includes(String(urlParams.isHome).toLowerCase());
  const shouldResetTopHeight = String(appBaseInfo?.webviewType) === '1' || isHome;
  const DPR = window.devicePixelRatio;
  const isImmerse = String(appBaseInfo?.h5Type) === '4' || String(appBaseInfo?.h5Type) === '2';
  const statusBarHeight = isIOS ? appBaseInfo?.status_bar_height || 0 : (appBaseInfo?.status_bar_height || 0) / DPR;

  /**
   * 初始化基础信息
   */
  const initBaseInfo = () => {
    if (shouldResetTopHeight) {
      statusHeight.value = 0;
      navHeight.value = 46 / (window as any)._fontSize;
			document.documentElement.classList.add('isHome');
    } else {
      statusHeight.value = isImmerse ? statusBarHeight / (window._fontSize || 37.5) : 0; // 状态栏高度,非沉浸式的时候为0
      navHeight.value = statusHeight.value + 46 / (window as any)._fontSize;
    }
    setStorage('statusHeight', statusHeight.value + '');
    setStorage('navHeight', navHeight.value + '');
    let body = document.body;
    body?.style.setProperty('--topHeight', statusHeight.value + 'rem');
    body?.style.setProperty('--navHeight', navHeight.value + 'rem');
  };

  provide('setPageScale', (value: number) => {
    pageScale = value;
    initPage();
  });

  /**
   * 初始化页面
   */
  const initPage = () => {
    setFontSize(designWidth, baseFontSize, pageScale);
    initBaseInfo();
  };
  const initToken = async () => {
    if (!isInDocoiApp()) return;

    let token = '';
    let tempToken = '';

    JSBridge.callAsync('getToken')
      .then((data) => {
        let objData: any = {};
        objData = data;
        token = objData.token || '';
        tempToken = objData.visitor_token || '';
        setStorage('docoiToken', JSON.stringify({ token, tempToken }));
        try {
          if (!token) return;
          getUserInfo().then((res) => {
            if (res.data?.code === 200 && res.data.data) {
              GlobalAuth.setLoginState(token, res.data.data);
            } else {
              GlobalAuth.setLoginState(token);
            }
          });
        } catch (error) {
          GlobalAuth.setLoginState(token);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  onMounted(() => {
    nextTick(() => {
      JSBridge.call('H5Loaded');
    });
    initToken();
    initPage();
    window.addEventListener('resize', initPage);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', initPage);
  });

  return {
    statusHeight,
    navHeight,
    initPage,
    initBaseInfo,
    initToken
  };
}
